// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface DeleteNotificationsRequestPayload {
  ids: number[];
  success: () => void;
}

export interface DeleteNotificationsSuccessPayload {}

export interface DeleteNotificationsFailPayload {
  error: Error;
}

export const deleteNotificationsActions = createAsyncAction(
  'elearning/POST_DELETE_NOTIFICATIONS',
  'elearning/POST_DELETE_NOTIFICATIONS_SUCCESS',
  'elearning/POST_DELETE_NOTIFICATIONS_FAIL'
)<
  DeleteNotificationsRequestPayload,
  DeleteNotificationsSuccessPayload,
  DeleteNotificationsFailPayload
>();
